var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20.455,
    viewBox: "0 0 25 20.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz48",
    d: "M14.472,26.455,6.233,21.937V15.119L2,12.818,14.472,6,27,12.818v9.006H25.3V13.812L22.71,15.119v6.818Zm0-8.75,8.949-4.886-8.949-4.8-8.892,4.8Zm0,6.818,6.534-3.608V16.142l-6.534,3.494L7.938,16.085v4.83ZM14.5,17.7ZM14.472,19.807ZM14.472,19.807Z",
    transform: "translate(-2 -6)",
    fill: "#00aeef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatButton);
export default __webpack_public_path__ + "static/media/hatButton.f89d8aed93b0ba5baa85f1cc56365973.svg";
export { ForwardRef as ReactComponent };